export const PRODUCTTYPES = ['BOOL','ITEM', 'LIST', 'SELECT', 'MULTIPLE']
